import { initTermsApp } from '~/terms';

initTermsApp();
